
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
  linkText: string;
  className?: string;
}

const ServiceCard = ({ title, description, icon, link, linkText, className = "" }: ServiceCardProps) => {
  return (
    <div className={`bg-white rounded-xl shadow-md hover:shadow-xl p-6 transition-all duration-300 h-full border border-autocare-gray-medium/30 ${className}`}>
      <div className="p-3 bg-autocare-blue/5 inline-block rounded-lg text-autocare-blue mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-gray-600 mb-5">{description}</p>
      <Link 
        to={link} 
        className="inline-flex items-center text-autocare-blue font-medium hover:text-autocare-blue-light transition-colors group"
      >
        {linkText}
        <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  );
};

export default ServiceCard;
